import type { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import type { QuizScreenProps, AnimatedMessageStepData } from '@packages/shared/core/quiz/entities';

type AnimatedMessageStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const AnimatedMessageStep = ({ id, renderQuizScreen }: AnimatedMessageStepProps) => {
  const logger = useLogger();

  const { back, next, stepData, userPreferences } = useQuizStep(id);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async () => {
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        userPreferences,
        ...(stepData as AnimatedMessageStepData),
      })}
    </>
  );
};

export default AnimatedMessageStep;
